module.exports = __webpack_public_path__ + "static/img/6.f6a3b58b.png";